import React, { useEffect, useState } from 'react';
import { Drawer, Link, Space, Tabs, Tag } from 'tdesign-react';
import styled from 'styled-components';
import { useMemoizedFn } from 'ahooks';
import { connect } from 'react-redux';
import { getBundleDataList, getConfigList, getTopicDataList } from '@/services/kopBrokerService';
import Configuration from '@/components/Cluster/Configuration';
import ModalHeader from '@/components/Header/Modal';
import Bundles from '@/components/Cluster/Bundles';
import Logs from '@/pages/KOPCluster/components/Logs';
import { getCurrentCluster } from '@/pages/Layout/MenuLayout/CulsterAddon';
import { updateBrokerService } from '@/services/kopClusterService';
import Summary from '../Summary';

const { TabPanel } = Tabs;

function Detail({ detail, clusterName, currentCluster }) {
  const [visible, setVisible] = useState(false);
  const [bundleData, setBundleData] = useState([]);
  const [loading, setLoading] = useState(false);

  const brokerHost = `${detail.host}:${detail.metricsPort}`;

  const handleClose = () => setVisible(false);

  const loadBundleData = useMemoizedFn(async () => {
    const { data } = await getBundleDataList({
      clusterName,
      brokerHost,
    });
    setBundleData(data);
  });

  const loadData = useMemoizedFn(async () => {
    setLoading(true);
    try {
      await loadBundleData();
    } catch (error) {
      console.trace(error);
      throw error;
    } finally {
      setLoading(false);
    }
  });

  useEffect(() => {
    if (visible) {
      loadData();
    }
  }, [loadData, visible]);

  return (
    <>
      <Link theme='primary' onClick={() => setVisible(true)}>
        <Space align='center' size='small'>
          {detail.leader && (
            <Tag theme='primary' variant='light'>
              leader
            </Tag>
          )}
          {detail.host}
        </Space>
      </Link>
      <Drawer
        visible={visible}
        size={1000}
        destroyOnClose
        header={
          <ModalHeader tags={[clusterName, `${detail.host}:${detail.port}`, detail.version]}>
            Broker
          </ModalHeader>
        }
        footer={null}
        onClose={handleClose}
      >
        <Body>
          <Summary overview={detail} />
          <Tabs defaultValue={1}>
            <TabPanel style={{ paddingTop: 20 }} value={1} label='Configuration' destroyOnHide>
              <Configuration
                loading={loading}
                configListService={() => getConfigList({ clusterName, brokerHost })}
                clusterName={clusterName}
                brokerHost={brokerHost}
                updateBrokerService={updateBrokerService}
              />
            </TabPanel>
            <TabPanel value={2} label='Bundles' destroyOnHide style={{ paddingTop: 20 }}>
              <Bundles
                loading={loading}
                originData={bundleData}
                getListRequest={getTopicDataList}
              />
            </TabPanel>
            {currentCluster?.deployEnv === 'vm' && (
              <TabPanel value={3} label='日志' destroyOnHide>
                <Logs host={detail.host} type='pulsar-broker' />
              </TabPanel>
            )}
          </Tabs>
        </Body>
      </Drawer>
    </>
  );
}

export default connect((state) => ({
  currentCluster: getCurrentCluster(state.kopCluster.allList),
}))(Detail);

const Body = styled.div`
  margin-top: -15px;
`;
